import { GLOBAL_COUNTRIES } from './countries-data'

export const EU_COUNTRIES = [
  'BE',
  'GR',
  'LT',
  'PT',
  'BG',
  'ES',
  'LU',
  'RO',
  'CZ',
  'FR',
  'HU',
  'SI',
  'DK',
  'HR',
  'MT',
  'SK',
  'DE',
  'IT',
  'NL',
  'FI',
  'EE',
  'CY',
  'AT',
  'SE',
  'IE',
  'LV',
  'PL',
]

export const COUNTRY_PRICING = {
  us: {
    currency: 'USD',
    vatPercentIncludedInPrice: 0,
  },
  ca: {
    currency: 'CAD',
    vatPercentIncludedInPrice: 0,
  },
  gb: {
    currency: 'GBP',
    vatPercentIncludedInPrice: 20,
  },
  de: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 19,
  },
  il: {
    currency: 'ILS',
    vatPercentIncludedInPrice: 18,
  },
  ie: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 23,
  },
  at: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 20,
  },
  nl: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 21,
  },
  se: {
    currency: 'SEK',
    vatPercentIncludedInPrice: 25,
  },
  dk: {
    currency: 'DKK',
    vatPercentIncludedInPrice: 25,
  },
  fi: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 24,
  },
  au: {
    currency: 'AUD',
    vatPercentIncludedInPrice: 10,
  },
  es: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 21,
  },
  fr: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 20,
  },
  be: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 21,
  },
  it: {
    currency: 'EUR',
    vatPercentIncludedInPrice: 22,
  },
  pl: {
    currency: 'PLN',
    vatPercentIncludedInPrice: 23,
  },
  jp: {
    currency: 'JPY',
    vatPercentIncludedInPrice: 10,
  },
}

const globalPricing = {
  currency: 'USD',
  vatPercentIncludedInPrice: 0,
}

// Add global countries to pricing config
for (const countryCode in GLOBAL_COUNTRIES) {
  COUNTRY_PRICING[countryCode.toLowerCase()] = globalPricing
}

// Set VAT for EU countries without specific pricing
for (const country of EU_COUNTRIES.map((country) => country.toLowerCase())) {
  // skips countries that already has their pricing (with the correct VAT)
  if (COUNTRY_PRICING[country].vatPercentIncludedInPrice > 0) {
    continue
  }
  // EU countries not in the list above, have the vat of the country the order is sent from (MT, GR are sent from US)
  // Currently they are all from germany

  // Perform shallow copy to globalPricing so changing finland VAT won't affect all
  COUNTRY_PRICING[country] = { ...COUNTRY_PRICING[country] }
  COUNTRY_PRICING[country].vatPercentIncludedInPrice = ['mt', 'cy'].includes(
    country
  )
    ? 0
    : COUNTRY_PRICING.de.vatPercentIncludedInPrice
}

export const PHOTO_BOOK_DEFAULT_PRICES = {
  BOOK_8X8: 49,
  BOOK_10X10: 79,
  BOOK_12X12: 99,
}
